import { useContext } from 'react'
import { useRequiredContext } from '../../../legacy/contexts/utils'
import { WarehouseContext } from './WarehouseContext'

export const useWarehouseContext = () => useRequiredContext(WarehouseContext)
export const useOptionalWarehouseContext = () => useContext(WarehouseContext)
